module.exports = __webpack_public_path__ + "assets/icons/ic_organization_viewer_24px.svg";